import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
const PageHero = ({title, product}) => {
  return <Wrapper>
             <div className='section-center'>
              <h3>
                <Link to='/'>Home</Link>{product && <Link to="/products">/ Products</Link>} / {title}
              </h3>
             </div>
    </Wrapper>
}

const Wrapper = styled.section`
  background: rgb(248, 200, 242);
  width: 100%;
  min-height: 20vh;
  display: flex;
  align-items: center;
h3{
  color:rgb(237, 182, 72);
}
  color: var(--clr-primary-1);
  a {
    color: rgb(138, 12, 126);
    padding: 0.5rem;
    transition: var(--transition);
  }
  a:hover {
    color: var(--clr-primary-1);
  }
`

export default PageHero
